import { useCallback, useContext, useEffect, useMemo } from 'react';

import styled from '@emotion/styled';
import { Loader } from '@myrealtrip/web-ui';
import { WebViewContext } from '@myrealtrip/device-detect';
import { getMobileAppVersion } from '@messenger/utils/getMobileAppVersion';

import type { ChannelsRequestParams } from '~models/MessengerDto';
import useCreateChannel from '~queries/messenger/useCreateChannel';

import Bridge from './Bridge';

function PromotionBridge() {
  const { isWebView } = useContext(WebViewContext);
  const urlSearchParams = new URL(window.location.href).searchParams;
  const gid = urlSearchParams.get('gid');
  const partnerId = urlSearchParams.get('partnerId');
  const { createAndOpenChannel, isLoading } = useCreateChannel();
  const [platform] = getMobileAppVersion(window.navigator.userAgent) || [];

  const param: ChannelsRequestParams = useMemo(
    () => ({
      gid: gid ? Number(gid) : null,
      partnerId: Number(partnerId),
    }),
    [gid, partnerId],
  );

  const goBack = useCallback(() => {
    window.history.back();
  }, []);

  const closeBridge = () => {
    window.history.back();
  };

  function renderWebviewBridge() {
    if (platform === 'android') {
      return <Bridge.Android param={param} />;
    }
    return <Bridge.Ios param={param} />;
  }

  const fetchChannel = useCallback(async () => {
    await createAndOpenChannel?.(param, goBack);
  }, [createAndOpenChannel, goBack, param]);

  useEffect(() => {
    if (!isWebView) {
      fetchChannel();
    }
  }, [createAndOpenChannel, fetchChannel, goBack, isWebView, param]);

  return isWebView ? (
    renderWebviewBridge()
  ) : (
    <Container>
      {isLoading || !isWebView ? (
        <Loader />
      ) : (
        <>
          <Content>
            상담을 잘 마치셨나요?
            <br />
            다른 상품을 살펴보기 위해 이 창을 닫아주세요
          </Content>
          <CloseButton onClick={closeBridge}>닫기</CloseButton>
        </>
      )}
    </Container>
  );
}

export default PromotionBridge;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100vw;
  min-height: 100dvh;
  font-size: 18px;
`;

const Content = styled.div`
  line-height: 1.5;
`;

const CloseButton = styled.button`
  margin: 50px auto 0;
  padding: 10px 30px;
  border-radius: 999px;
  background-color: #141719;
  color: #ffffff;
  border: none;
  font-size: 16px;
`;
